import { Injectable } from '@angular/core';

//importaciones supertokens
import { signIn, signUp } from 'supertokens-web-js/recipe/emailpassword';
import { signOut as superTokensSignOut } from 'supertokens-web-js/recipe/session';
import Session from "supertokens-web-js/recipe/session";
import { EmailVerificationClaim } from "supertokens-web-js/recipe/emailverification";
import { sendVerificationEmail } from "supertokens-web-js/recipe/emailverification";

//Uso esta liabreria ngx-cookie-service para manejar las cookies
import { CookieService } from 'ngx-cookie-service';
import { getAuthorisationURLWithQueryParamsAndSetState, signInAndUp } from 'supertokens-web-js/recipe/thirdparty';

@Injectable({
    providedIn: 'root'
})
export class SupertokensService {

    constructor(
        private cookieService: CookieService

    ) { }

    signUpClicked(email: string, password: string, nombre: string, apellido: string): Promise<any> {
        //Documentación: https://supertokens.com/docs/emailpassword/custom-ui/email-password-login

        //Convierto el observable de la documentación en promesa para manejar mejor la respuesta en el componente
        return new Promise(async (resolve, reject) => {

            try {
                let response = await signUp({
                    formFields: [{
                        id: "email",
                        value: email
                    }, {
                        id: "password",
                        value: password
                    }, {
                        id: "nombre",
                        value: nombre
                    }, {
                        id: "apellido",
                        value: apellido
                    }
                    ],
                })

                switch (response.status) {
                    case "OK":
                        resolve(response); // Resolve promise
                        break;

                    case "FIELD_ERROR":
                        // one of the input formFields failed validation
                        response.formFields.forEach(formField => {
                            if (formField.id === "email") {
                                // Email validation failed (for example incorrect email syntax),
                                // or the email is not unique.
                                reject('Error en campo email'); // Reject promise with error

                            } else if (formField.id === "password") {
                                // Password validation failed.
                                // Maybe it didn't match the password strength
                                reject(formField.id); // Reject promise with error

                            }
                        })

                        break;

                    case "SIGN_UP_NOT_ALLOWED":
                        reject(response.reason); // Reject promise with error
                        break;

                    default:
                        break;
                }

            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {

                    reject(err.message); // Reject promise with error
                } else {
                    reject("Error general. Algo salio mal!"); // Reject promise with error
                }
            }
        });

    }


    signInClicked(email: string, password: string, cuit?: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await fetch('https://newnuvalid-dev.tx.puntosalud.ar/api/v1/nuvalid/supertokens/signin', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({
                        formFields: [
                            { id: "email", value: email },
                            { id: "password", value: password }
                        ]
                    })
                });

                const json = await res.json();

                const statusStr = json.supertokens?.status || json.status;
                const reasonStr = json.supertokens?.reason || json.reason;
                const userData = json.usuario || null;
                const instalaciones = json.instalaciones || [];

                if (statusStr === 'OK') {
                    const sessionUser = await this.getSessionUser();
                    const normalizedUserData: any = { ...(userData || {}) };

                    if (sessionUser && typeof sessionUser === 'object') {
                        for (const field in sessionUser) {
                            if (field !== 'id' && sessionUser[field] !== null && sessionUser[field] !== undefined) {
                                normalizedUserData[field] = sessionUser[field];
                            }
                        }
                    }

                    // `usuario.id` is the Nuvalid ID required by agenda scheduling;
                    // SuperTokens claims use a separate identity domain.
                    normalizedUserData.id = userData?.id ?? '';

                    resolve({ status: 'OK', userData: normalizedUserData, instalaciones });
                } else if (statusStr === 'FIELD_ERROR') {
                    reject({ status: 400, message: 'Error en campo email' });
                } else if (statusStr === 'WRONG_CREDENTIALS_ERROR') {
                    reject({ status: 401, message: 'Email o contraseña incorrecto' });
                } else if (statusStr === 'SIGN_IN_NOT_ALLOWED') {
                    reject({ status: 412, message: reasonStr || 'El usuario necesita seleccionar un rol' });
                } else {
                    reject({ status: 500, message: 'Respuesta desconocida del backend' });
                }

            } catch (err) {
                reject(new Error('Error general. Algo salió mal!'));
            }
        });
    }

    /**
     * Returns the user claims verified and managed by SuperTokens. Do not decode
     * the access token, front token, or response headers in application code.
     */
    async getSessionUser(): Promise<any | null> {
        try {
            const payload = await Session.getAccessTokenPayloadSecurely();
            return payload?.usuario || null;
        } catch {
            return null;
        }
    }



    async signOut(): Promise<void> {
        try {
            await superTokensSignOut();
        } catch (error) {
            console.error('Error al cerrar sesión', error);
        }
    }

    async emailVerificado(): Promise<boolean> {
        //Documentación: https://supertokens.com/docs/emailpassword/custom-ui/enable-email-veri

        if (await Session.doesSessionExist()) {
            let validationErrors = await Session.validateClaims();
            if (validationErrors.length === 0) {
                // user has verified their email address
                return true;
            } else {
                for (const err of validationErrors) {
                    if (err.id === EmailVerificationClaim.id) {
                        // email is not verified
                    }
                }
            }
        }
        // a session does not exist, or email is not verified
        return false
    }


    async sendEmail(): Promise<any> {

        //Documentación:
        return new Promise(async (resolve, reject) => {

            try {
                let response = await sendVerificationEmail();
                if (response.status === "EMAIL_ALREADY_VERIFIED_ERROR") {
                    // This can happen if the info about email verification in the session was outdated.
                    // Redirect the user to the home page
                    //window.location.assign("/home");
                    reject("EMAIL_ALREADY_VERIFIED_ERROR")
                } else {
                    // email was sent successfully.
                    resolve(response)
                    //window.alert("Please check your email and click the link in it")
                }
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    // this may be a custom error message sent from the API by you.
                    //window.alert(err.message);
                    reject(err.message)

                } else {
                    reject("Oops!, algo salio mal")


                }
            }
        });
    }

    async googleSignInClicked(): Promise<any> {

        return new Promise(async (resolve, reject) => {

            try {
                const authUrl = await getAuthorisationURLWithQueryParamsAndSetState({
                    thirdPartyId: "google",
                    // This is where Google should redirect the user back after login or error.
                    // This URL goes on the Google's dashboard as well.
                    frontendRedirectURI: "http://localhost:3000/google",
                });
                resolve(authUrl)
                window.location.assign(authUrl);
                /*
                Example value of authUrl: https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&include_granted_scopes=true&response_type=code&client_id=1060725074195-kmeum4crr01uirfl2op9kd5acmi9jutn.apps.googleusercontent.com&state=5a489996a28cafc83ddff&redirect_uri=https%3A%2F%2Fsupertokens.io%2Fdev%2Foauth%2Fredirect-to-app&flowName=GeneralOAuthFlow
                */

                // we redirect the user to google for auth.
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    // this may be a custom error message sent from the API by you.
                    reject(err.message)
                    //window.alert(err.message);
                } else {
                    reject("Error general. Algo salió mal!")
                    //window.alert("Oops! Something went wrong.");
                }
            }
        });
    }

    async handleGoogleCallback(): Promise<any> {

        return new Promise(async (resolve, reject) => {

            try {
                const response = await signInAndUp();

                if (response.status === "OK") {

                    if (response.createdNewRecipeUser && response.user.loginMethods.length === 1) {
                        // sign up successful
                        resolve(response)
                    } else {
                        // sign in successful
                        resolve(response)
                    }
                    //window.location.assign("/home");
                } else if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
                    // the reason string is a user friendly message
                    // about what went wrong. It can also contain a support code which users
                    // can tell you so you know why their sign in / up was not allowed.
                    reject(response.reason)
                } else {
                    // SuperTokens requires that the third party provider
                    // gives an email for the user. If that's not the case, sign up / in
                    // will fail.

                    // As a hack to solve this, you can override the backend functions to create a fake email for the user.
                    reject("No email provided by social login. Please use another form of login");
                    //window.location.assign("/auth"); // redirect back to login page
                }
            } catch (err: any) {
                if (err.isSuperTokensGeneralError === true) {
                    // this may be a custom error message sent from the API by you.
                    reject(err.message);
                } else {
                    reject("Oops! Something went wrong.");
                }
            }
        });
    }

    get accesToken() {

        let token: any = this.cookieService.get('st-access-token') || null
        return token;

    }

}
